import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type DealCommentRow = {
  id: string;
  deal_id: string;
  author_id: string;
  author_type: string;
  content: string;
  created_at: string;
  /**
   * Synthetic flag set on optimistic rows the mutation hook appends before
   * the server response lands. Real rows from /api/portal/deals/.../comments
   * never carry it. The comment-thread UI renders pending rows with reduced
   * opacity to signal "in flight".
   */
  pending?: boolean;
};

// GET /api/portal/deals/:dealId/comments — partner-visible thread.
export function useDealComments(dealId: string | undefined) {
  return useQuery<DealCommentRow[], ApiClientError>({
    queryKey: queryKeys.deals.comments(dealId ?? ""),
    queryFn: () => apiFetch<DealCommentRow[]>(`/portal/deals/${dealId}/comments`),
    enabled: !!dealId,
  });
}
